/**
 * ClawInstall admin layout route — eagerly registers the file route and its
 * `beforeLoad` admin guard (which runs server-side); the layout component and
 * its atom/RPC imports are deferred to `admin.lazy.tsx` so they load only with
 * this route, never in the always-loaded `main` chunk (CLA-645).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { requireAdmin } from "~/lib/server-admin.ts";

/* v8 ignore start -- @preserve - beforeLoad runs server-side, tested through E2E */
export const Route = createFileRoute("/clawinstall/admin")({
  // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await
  beforeLoad: async () => {
    // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await
    const auth = await requireAdmin();
    return { auth };
  },
});
/* v8 ignore stop */
